import { html, render } from 'lit';
import { bootstrapApplicationContext } from './context';
import './global-application-context.element';
export async function bootstrapApplication(entryPointFactory, env) {
    await Promise.all([entryPointFactory(), bootstrapApplicationContext(env)]);
    const template = html `
    <global-application-context>
      <app-root id="app-root"></app-root>
      <div id="overlay-container"></div>
    </global-application-context>
  `;
    render(template, document.body);
}
//# sourceMappingURL=bootstrap.js.map